import React from 'react';
// helpers
import { getLocalDate } from 'helpers';
// scss
import './PassengerItem.scss';

const PassengerItemMobile = ({
  data,
  idx,
  selectedPassengersIds,
  handleSelect,
  isSuperAdmin
}) => {
  const {
    passenger_id,
    departure_date,
    full_name,
    phone,
    ticket_price,
    number_of_tickets,
    seats,
    departure_point,
    arrival_point,
    comment,
    creator_name,
    ticket_status,
  } = data ?? {};
  const departureDate = getLocalDate(departure_date);
  const ticketPrice = `${ticket_price}€`;
  const direction = `${departure_point}-${arrival_point}`;

  return (
    <li key={passenger_id || idx} className="passengers__item passenger">
      <div className="passenger-mobile__row passenger-mobile__row--border-none" style={{justifyContent: 'flex-end'}}>
        <span className="passenger__departure-date">{departureDate}</span>
      </div>
      <div className="passenger-mobile__row passenger-mobile__row--border-none">
        <div className="passenger__checkbox-wrap">
          <input
            className="passenger__checkbox"
            type="checkbox"
            name="passenger"
            id={passenger_id}
            checked={selectedPassengersIds?.includes(passenger_id)}
            onChange={() => handleSelect(passenger_id)}
          />
          <label className="passenger__checkbox-label" htmlFor={passenger_id}>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="14"
              height="14"
              viewBox="0 0 14 14"
              fill="none"
            >
              <path
                d="M11.6673 3.5L5.25065 9.91667L2.33398 7"
                stroke="white"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </label>
        </div>
        <span className="passenger__full-name">{full_name}</span>
      </div>
      <div className="passenger-mobile__row passenger-mobile__row--border-none">
      <span className="passenger__phone">{phone}</span>
      </div>
      <div className="passenger-mobile__row">
        <span className="assenger-mobile__row-title"> Ціна квитка </span>
        <span className={`passenger__ticket-price passenger__ticket-status passenger__ticket-status--${ticket_status}`}>{ticketPrice}</span>
      </div>
      <div className="passenger-mobile__row">
        <span className="assenger-mobile__row-title"> К-ість квитків </span>
        <span className="passenger__number-of-tickets">{number_of_tickets}</span>
      </div>
      <div className="passenger-mobile__row">
        <span className="assenger-mobile__row-title"> Місце </span>
        <span className="passenger__seats">{seats || '-'}</span>
      </div>
      <div className="passenger-mobile__row">
        <span className="assenger-mobile__row-title"> Напрям </span>
        <span className="passenger__direction">{direction}</span>
      </div>
      <div className="passenger-mobile__row">
        <span className="assenger-mobile__row-title"> Коментар </span>
        <span className="passenger__comment">{comment || '-'}</span>
      </div>
      {isSuperAdmin &&
      <div className="passenger-mobile__row">
        <span className="assenger-mobile__row-title"> Від кого пасажир </span>
         <span className="passenger__creator-name">{creator_name}</span>
      </div>
      }
    </li>
  );
};

export default PassengerItemMobile;
